import { startCase } from 'lodash-es';

import { GCPBillingDisplayStatus } from './types';

const usageMonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const normalizeGCPBillingStatus = (
  invoiceStatus?: string,
  reason?: string
): GCPBillingDisplayStatus => {
  const normalizedStatus = invoiceStatus?.trim().toLowerCase();

  if (normalizedStatus === 'created') {
    return { kind: 'created', label: 'Created' };
  }
  if (normalizedStatus === 'processing') {
    return { kind: 'processing', label: 'Processing' };
  }
  if (normalizedStatus === 'skipped') {
    return { kind: 'skipped', label: 'Skipped' };
  }
  if (normalizedStatus === 'failed') {
    return { kind: 'failed', label: 'Failed' };
  }
  if (normalizedStatus === 'skipped_failed') {
    const normalizedReason = reason?.trim().toLowerCase();

    return normalizedReason?.startsWith('skipped:')
      ? { kind: 'skipped', label: 'Skipped' }
      : { kind: 'failed', label: 'Failed' };
  }
  if (!normalizedStatus) {
    return { kind: 'unknown', label: 'Unknown' };
  }

  return { kind: 'unknown', label: startCase(invoiceStatus) };
};

export const formatGCPUsageMonth = (value?: string): string => {
  if (!value) return '—';

  const match = /^(\d{4})(0[1-9]|1[0-2])$/.exec(value);

  if (!match) return value;

  return `${usageMonthNames[Number(match[2]) - 1]} ${match[1]}`;
};
